export default {"src":"/_next/static/media/couch.7e9a03d5.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};